export default {"src":"/_next/static/media/website.32068be0.svg","height":18,"width":18};